<template>
  <div>
    <a-drawer title="工单详情" :width="1300" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="close">
      <a-card class="problem-detail" size="small" :loading="loading">
        <div>
          <a-page-header>
            <template slot="extra">
              <a-button type="primary" :disabled="problemData.isMaintainer === 0 && problemData.isHandler == 0" style="margin-left: 5px" @click="addResult">工单完结</a-button>
              <a-button type="primary" :disabled="problemData.isMaintainer === 0 && problemData.isHandler == 0" style="margin-left: 5px" @click="doBack">工单打回</a-button>
              <a-button type="primary" :disabled="problemData.isMaintainer === 0 && problemData.isHandler == 0" style="margin-left: 5px" @click="addMessage">补充信息</a-button>
              <a-dropdown>
                <a-menu slot="overlay">
                  <a-menu-item key="1" @click="toReq()"> 转需求</a-menu-item>
                  <a-menu-item key="2" @click="toBug()"> 转缺陷</a-menu-item>
                  <a-menu-item key="4" @click="copy()"> 分享</a-menu-item>
                  <!-- <a-menu-item key="3" @click="taged()"> 标记</a-menu-item> -->
                </a-menu>
                <a-button style="margin-left: 5px">更多</a-button>
              </a-dropdown>

              <!-- <a-button type="primary" style="margin-left :5px" @click="goToQiyu">跳转七鱼工单</a-button> -->
              <ticket-status-change-modal ref="ticketStatusChangeModal" :title="modalTitle" @callback="giveResult" />
            </template>
            <template slot="title">
              <div v-if="problemData.is_fault" class="corner" @click="onViewFault" />
              <ticket-name-edit :name="problemData.name" :task-id="problemData.id" @callback="onReload" />
            </template>
            <a-descriptions size="small">
              <a-descriptions-item label="当前状态">
                <ticket-flow-edit :key="key" :tag-list="ticketStatus" :ticket-data="problemData" flag="status" @callback="onReload" />
              </a-descriptions-item>
              <a-descriptions-item label="紧急程度">
                <ticket-flag-edit :is-maintainer="problemData.isMaintainer === 0 && problemData.isHandler == 0" :ticket-id="problemData.id" :tag-list="ticketLevel" :status="problemData.level" flag="level" />
              </a-descriptions-item>
              <a-descriptions-item label="业务域">
                <ticket-flag-edit :is-maintainer="problemData.isMaintainer === 0 && problemData.isHandler == 0" :ticket-id="problemData.id" :tag-list="ticketDomain" :status="problemData.domain" flag="domain" @callback="onReload" />
              </a-descriptions-item>
              <!-- <a-descriptions-item v-if="handlerModifyPermission()" label="工单标记">
                <a-select v-model="ticketUserTags" mode="multiple" how-search placeholder="请选择您的标记" @change="onSubmit" style="width: 240px">
                  <a-select-option v-for="(reason, index) in ticketUserTag" :key="index" :value="reason.value">{{ reason.label }} </a-select-option>
                </a-select>
              </a-descriptions-item> -->
              <a-descriptions-item label="问题类型">
                <ticket-tag-edit :is-maintainer="problemData.isMaintainer === 0 && problemData.isHandler == 0" :ticket-id="problemData.id" :tag-list="problemTags" :status="problemData.tags" flag="tags" @callback="onReload" />
              </a-descriptions-item>
              <a-descriptions-item label="工单排查人">
                <a-select v-model="problemData.handler" show-search placeholder="工单处理人" :filter-option="utils.filterOption" style="width: 120px; border: none" @change="handlerChange">
                  <a-select-option v-for="(user, index) in userData" :key="index" :value="user.fs_user_id">{{ user.nickname }} </a-select-option>
                </a-select>
              </a-descriptions-item>
              <a-descriptions-item label="工单对接人">
                <a-select v-model="problemData.maintainer" mode="multiple" placeholder="处理人" :filter-option="utils.filterOption" disabled>
                  <a-select-option v-for="(user, index) in userData" :key="index" :value="user.fs_user_id">{{ user.nickname }} </a-select-option>
                </a-select>
              </a-descriptions-item>
              <a-descriptions-item label="渠道">
                <a-tag v-if="problemData.from == 1">{{ '乐狐七鱼' }}</a-tag>
                <a-tag v-if="problemData.from == 2">{{ '香港企点' }}</a-tag>
                <a-tag v-if="problemData.from == 3" color="red">{{ '香港业务方' }}</a-tag>
              </a-descriptions-item>
              <a-descriptions-item label="工单创建人">
                {{ '客服' + problemData.creator }}
                <!-- <a-select v-model="problemData.maintainer" mode="multiple" placeholder="处理人" :filter-option="utils.filterOption" disabled>
                  <a-select-option v-for="(user, index) in userData" :key="index" :value="user.fs_user_id">{{ user.nickname }} </a-select-option>
                </a-select> -->
              </a-descriptions-item>

              <a-descriptions-item label="用户反馈时间"> {{ problemData.userCreateTime }} </a-descriptions-item>
              <a-descriptions-item label="渠道工单创建时间"> {{ problemData.qiyuCreatedTime }} </a-descriptions-item>
              <a-descriptions-item label="上报产研时间"> {{ problemData.created_time }} </a-descriptions-item>
              <a-descriptions-item label="工单id">
                <span @click="onCopy(problemData.id)">{{ problemData.id }}</span>
              </a-descriptions-item>
              <!-- <a-descriptions-item label="已接手时长"> {{ problemData.updated_time }} </a-descriptions-item> -->
            </a-descriptions>
          </a-page-header>
          <a-row :gutter="16">
            <a-col :span="14">
              <a-card>
                <a-tabs v-model="tabsActiveKey" size="small">
                  <a-tab-pane key="1" tab="问题详情">
                    <div class="problem-content"><vditor-preview width="200px" :content="buildContent()" /></div>
                  </a-tab-pane>
                  <a-tab-pane key="2" tab="变更日志" force-render> <ticket-record ref="record" :source-id="problemData.id" :ticket-tag-list="problemTags" /> </a-tab-pane>
                  <a-tab-pane key="3" tab="用户会话" force-render> <ticket-connection :connection-list="problemData.connectionList" /> </a-tab-pane>
                  <a-tab-pane key="4" tab="关联信息" force-render> <ticket-more-info :relations="problemData.relations" /> </a-tab-pane>

                  <a-tab-pane key="5" tab="AI总结" force-render> <ticket-ai-info :ai-info="aiInfo" /> </a-tab-pane>
                </a-tabs>
              </a-card>
            </a-col>
            <a-col :span="10">
              <ticket-comment ref="comment" :ticket-info="problemData" @callback="onReload" />
            </a-col>
          </a-row>
        </div>
      </a-card>
    </a-drawer>
    <issue-edit-modal ref="editModalRef" :source-type="sourceType" @close="close" @callback="updateTicketRelation" />
    <story-edit :visible="reqCreateVisible" :source-id="problemData.id" :source-type="sourceType" @close="close" @callback="updateTicketRelation" />
    <a-modal v-model="tagMoalVisible" title="请编辑标记" :width="500" centered :mask-closable="false" @cancel="modalClose" @ok="onSubmit">
      <a-descriptions size="small">
        <a-descriptions-item label="工单标记：">
          <a-select v-model="ticketUserTags" mode="multiple" how-search placeholder="请选择您的标记" style="width: 240px">
            <a-select-option v-for="(reason, index) in ticketUserTag" :key="index" :value="reason.value">{{ reason.label }} </a-select-option>
          </a-select>
        </a-descriptions-item>
      </a-descriptions>
    </a-modal>
  </div>
</template>
<script>
import { userList } from '@/api/system/auth';
import { onCopy, permissionRequired } from '@/utils/utils';
import { modifyTicketFlag, getNextTicket, ticketDetail, ticketTags, ticketReply } from '@/api/event/problem';
import { ticketLevel, ticektTag, problemFrequencys, problemTypes, problemStatus, TicketStatus, ticketDomain, ticketStatus, ticketUserTag } from '@/utils/dictionary';

import VditorPreview from '@/components/VditorEditor/preview';
import TicketRecord from '@/pages/event/components/TicketRecord';
import TicketAiInfo from '@/pages/event/components/TicketAiInfo';
import StoryEdit from '@/pages/project/story/components/StoryEdit';
import TicketComment from '@/pages/event/components/TicketComment';
import TicketTagEdit from '@/pages/event/components/TicketTagEdit';
import TicketFlagEdit from '@/pages/event/components/TicketFlagEdit';
import TicketNameEdit from '@/pages/event/components/TicketNameEdit';
import TicketFlowEdit from '@/pages/event/components/TicketFlowEdit';
import TicketMoreInfo from '@/pages/event/components/TicketMoreInfo';
import TicketConnection from '@/pages/event/components/TicketConnection';
import IssueEditModal from '@/pages/project/issue/components/IssueEditModal';
import TicketStatusChangeModal from '@/pages/event/components/TicketStatusChangeModal';

export default {
  components: {
    StoryEdit,
    TicketAiInfo,
    TicketRecord,
    VditorPreview,
    TicketComment,
    TicketTagEdit,
    TicketFlagEdit,
    TicketFlowEdit,
    TicketNameEdit,
    IssueEditModal,
    TicketMoreInfo,
    TicketConnection,
    TicketStatusChangeModal
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    ticketId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      nextId: 0,
      key: 0,
      id: 0,
      sourceType: 'ticket',
      reqCreateVisible: false,
      tagMoalVisible: false,
      modalTitle: '',
      aiInfo: {},
      problemTypes,
      ticketUserTags: [],
      ticketUserTag,
      problemStatus,
      problemTags: [],
      ticketDomain,
      ticketLevel,
      ticketStatus,
      ticektTag,
      resultStatus: null,
      ticketModalShow: false,
      inputValue: '',
      problemFrequencys,
      TicketStatus,
      modalVisible: false,
      loading: true,
      problemData: {},
      userData: [],
      tabsActiveKey: '1',
      activeKeys: ['1'],
      statusOptions: [],
      req: {
        id: '',
        name: '',
        handler: '',
        maintainer: '',
        tags: '',
        level: '',
        status: '',
        domain: ''
      }
    };
  },
  created() {
    this.getProblemDetail();
    this.getUserList();
    this.getTicketTags();
  },

  methods: {
    handlerModifyPermission() {
      return key => {
        return permissionRequired('ticket:tag:show', 1);
      };
    },
    close() {
      this.$emit('close');
    },
    modalClose() {
      this.tagMoalVisible = false;
    },
    toReq() {
      this.reqCreateVisible = true;
    },
    toBug() {
      this.$nextTick(() => {
        this.$refs.editModalRef.onOpen({});
      });
    },
    taged() {
      this.tagMoalVisible = true;
    },
    onCopy,
    // 获取问题详情
    getProblemDetail() {
      this.id = this.ticketId;
      getNextTicket({ ticketId: this.id })
        .then(res => {
          this.nextId = res.data.id;
        })
        .catch(() => {
          this.loading = false;
        });
      ticketDetail({ id: this.id })
        .then(res => {
          this.problemData = res.data;
          if (this.problemData.relations === null) {
            this.problemData.relations = [];
          }
          this.ticketUserTags = res.data.refers;
          this.aiInfo = JSON.parse(this.problemData.aiInfo);
          this.key = this.key + 1;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    goNext() {
      this.$router.push({
        name: 'page:event:ticket:detail',
        query: { ticketId: this.nextId }
      });
      this.id = this.nextId;
      this.getProblemDetail();
    },
    getUserById(user_id) {
      const user = this.userData.find(item => item.fs_user_id === user_id);
      return user.nickname;
    },
    handlerChange(value) {
      this.req.id = this.problemData.id;
      this.req.name = this.problemData.name;
      this.req.handler = value;
      const req = this.req;
      modifyTicketFlag({ req }).then(() => {});
    },
    submit() {},
    updateTicketRelation(value, type) {
      this.req.id = this.problemData.id;
      this.req.name = this.problemData.name;
      this.problemData.relations.push({
        sourceType: type,
        sourceId: value.id
      });
      this.req.relations = this.problemData.relations;
      const req = this.req;
      modifyTicketFlag({ req }).then(() => {});
    },
    getTicketTags() {
      ticketTags({}).then(res => {
        this.problemTags = res.data.items;
      });
    },
    copy() {
      const shareUrl = 'https://devops.cdfsunrise.com/event/ticketDetail?ticketId=' + this.problemData.id;
      onCopy(shareUrl);
    },

    maintainerChange(value) {
      this.req.id = this.problemData.id;
      this.req.name = this.problemData.name;
      this.req.maintainer = value;
      const req = this.req;
      modifyTicketFlag({ req }).then(() => {});
    },
    buildContent() {
      let content = '';
      if (this.problemData.meta && this.problemData.meta.image && this.problemData.meta.image.length > 0) {
        for (let i = 0; i < this.problemData.meta.image.length; i++) {
          const url = this.problemData.meta.image[i];
          let cardString;

          if (url.includes('mp4')) {
            cardString = `[Screenrecording_123.mp4](${url})`;
          } else {
            cardString = `![image.png](${url})`;
          }
          content += cardString;
        }
      }
      if (this.problemData.meta && this.problemData.meta.desc) {
        content = this.problemData.meta.desc + '\n' + content;
      }

      return content;
    },
    onReload() {
      this.getProblemDetail();
    },
    goToQiyu() {
      window.open('https://cdfsunrise.qiyukf.com/worksheet/home/detail?id=' + this.problemData.qiyuTicketId);
    },
    doBack() {
      this.modalTitle = '您将操作打回工单，请给出原因';
      this.resultStatus = 6;
      this.$refs.ticketStatusChangeModal.open(this.problemData.status, this.resultStatus, 1);
    },
    addMessage() {
      this.modalTitle = '请输入需要客服补充的内容';
      this.resultStatus = 8;
      this.$refs.ticketStatusChangeModal.open(this.problemData.status, this.resultStatus, 0);
    },
    addResult() {
      console.log(this.problemData);
      if (this.problemData.tags === '1' && this.problemData.type != 3) {
        alert('问题类型还未分配，请补充问题类型');
      }
      if (this.problemData.domain === '0' && this.problemData.type != 3) {
        alert('业务域还未划分，请划分业务域');
      }
      if ((this.problemData.tags !== '1' && this.problemData.domain !== '0') || this.problemData.type == 3) {
        this.modalTitle = '请输入结论';
        this.resultStatus = 3;
        this.$refs.ticketStatusChangeModal.open(this.problemData.status, this.resultStatus, 2);
      }
    },
    giveResult(comment, value) {
      var result = '';
      if (this.resultStatus === 6) {
        result = '【打回】' + comment;
        this.problemData.doBack = 1;
      } else if (this.resultStatus === 8) {
        result = '【补充信息】' + comment;
        this.problemData.needMessage = 1;
      } else {
        this.resultStatus = value;
        result = '【完结】' + comment;
      }

      this.problemData.status = this.resultStatus;
      if (this.problemData.reply == null) {
        this.problemData.reply = [];
      }
      const replyInfo = {
        desc: result,
        createdTime: '',
        reporter: {
          nickNanme: '',
          avatarUrl: ''
        },
        isResult: 1,
        from_to: this.problemData.from,
        ticketId: this.problemData.id,
        qiyuTicketId: this.problemData.qiyuTicketId,
        doBack: this.problemData.doBack,
        needMessage: this.problemData.needMessage
      };

      this.problemData.reply.push(replyInfo);
      this.problemData.isResult = true;
      this.req.id = this.problemData.id;
      this.req.name = this.problemData.name;
      this.req.status = this.resultStatus;
      const req = this.req;
      modifyTicketFlag({ req }).then(() => {
        this.onReload();
      });
      ticketReply({ replyInfo })
        .then(res => {})
        .catch(() => {
          this.loading = false;
        });
      this.ticketModalShow = false;
    },
    getUserList() {
      userList({}).then(res => {
        this.userData = res.data.users.filter(user => user.isDeleted !== 1 && user.fs_user_id !== '' && user.fs_user_id !== null);
      });
    },
    onSubmit(value) {
      this.req.id = this.problemData.id;
      this.req.refers = this.ticketUserTags;
      modifyTicketFlag({ req: this.req }).then(() => {
        this.tagMoalVisible = false;
      });
    },
    onAddComment() {
      if ('1'.includes(this.activeKeys) === false) {
        this.activeKeys.push('1');
      }
      this.$refs['comment'].onAddComment();
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.problem-detail {
  .ant-card-body {
    padding: 16px;
  }
  .ant-divider-horizontal {
    margin: 8px 0px;
  }
  .ant-page-header {
    padding: 0;
  }
}

/deep/.ant-page-header-footer {
  margin-top: 0px;
  .ant-tabs-bar .ant-tabs-nav .ant-tabs-tab {
    font-size: 14px;
    font-weight: bold;
  }
}
/deep/.vditor-reset {
  width: auto;
  img {
    max-width: 30%; /* 图片最大宽度为容器宽度 */
    height: auto; /* 高度自动，保持图片的比例 */
  }
}

/deep/.info {
  .ant-descriptions-title {
    margin-bottom: 8px;
  }
  .ant-descriptions-item {
    padding-left: 8px;
    span {
      float: left;
    }
  }
}
/deep/.task {
  .ant-descriptions-title {
    margin-bottom: 8px;
  }
}

.problem-panel {
  border-radius: 4px;
  border: 0;
  background: #fafafa;
  overflow: hidden;
}

.problem-content {
  background: rgb(250, 250, 250);
}

.collapse-button {
  color: #86909c;
}

.corner {
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
}
.fixed-col {
  position: relative;
  background: #fafafa;
}

.corner::before {
  position: absolute;
  top: -11px;
  left: 24px;
  font-size: 12px;
  height: 16px;
  content: 'RCA';
  border-radius: 2px 2px 2px 0px;
  padding: 2px 4px;
  line-height: 12px;
  color: #fff;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.4), transparent) #ec374d;
  background-blend-mode: soft-light;
}

.corner::after {
  position: absolute;
  content: '';
  left: 24px;
  clip-path: polygon(0 0, 5px 0, 5px 5px);
  width: 12px;
  height: 12px;
  top: 5px;
  /* 颜色变暗：filter滤镜、半透明遮罩 */
  /* 使用filter滤镜 使颜色变暗 */
  /*filter: brightness(.6);*/
  /* 给颜色上添加一个半透明遮罩实现颜色变暗 */
  background: linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3));
  background-color: inherit; /* 继承 */
}
</style>
